// 必要なVueファイルをimportする
import Login from '../views/Login';
import Home from '../views/Home';
import Manual from '../views/Manual';
import Rule from '../views/Rule';
import MotPhone from '../views/MotPhone';
import Notification from '@/views/Notification';
import TelephoneLine from '../views/TelephoneLine';
import TelephoneOutline from '../views/TelephoneOutline';
import EmergencyContact from '../views/EmergencyContact';
import CellPhone from '../views/CellPhone';
import UiUx from '../views/UiUx';
import CellPhoneList from '../views/CellPhoneList';
import NotificationList from '@/views/NotificationList';
import Regulation from '@/views/Regulation';
import PhoneLost from '../views/PhoneLost';
import Welfare from '../views/Welfare';
import WelfareList from '../views/WelfareList';
import GuidelinesForAction from '@/views/GuidelinesForAction';

// パスとVueファイルの定義
const MrtRoute = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { title: 'ログイン' },
  },
  {
    path: '/mrt/home',
    name: 'home',
    component: Home,
    meta: { title: 'ホーム' },
  },
  {
    path: '/mrt/manual',
    name: 'manual',
    component: Manual,
    meta: { title: '申請書・マニュアル' },
  },
  {
    path: '/mrt/rule',
    name: 'rule',
    component: Rule,
    meta: { title: 'オフィス内設備ルール' },
  },
  {
    path: '/mrt/motPhone',
    name: 'motPhone',
    component: MotPhone,
    meta: { title: 'IP電話' },
  },
  {
    path: '/mrt/notification/:id',
    name: 'notification',
    component: Notification,
    meta: { title: 'おしらせ' },
    props: true,
  },
  {
    path: '/mrt/telephoneLine',
    name: 'telephoneLine',
    component: TelephoneLine,
    meta: { title: 'レポートライン一覧表' },
  },
  {
    path: '/mrt/telephoneOutline',
    name: 'telephoneOutline',
    component: TelephoneOutline,
    meta: { title: '内線外線図' },
  },
  {
    path: '/mrt/emergencyContact',
    name: 'emergencyContact',
    component: EmergencyContact,
    meta: { title: '緊急連絡体制' },
  },
  {
    path: '/mrt/cellPhone',
    name: 'cellPhone',
    component: CellPhone,
    meta: { title: '社用携帯に関するお知らせ' },
  },
  {
    path: '/mrt/uiUx',
    name: 'uiUx',
    component: UiUx,
    meta: { title: 'UiUx' },
  },
  {
    path: '/mrt/cellPhoneList',
    name: 'cellPhoneList',
    component: CellPhoneList,
    meta: { title: '社用携帯電話番号一覧' },
  },
  {
    path: '/mrt/notificationList',
    name: 'notificationList',
    component: NotificationList,
    meta: { title: 'お知らせ一覧' },
  },
  {
    path: '/mrt/regulation',
    name: 'regulation',
    component: Regulation,
    meta: { title: '社内規程' },
  },
  {
    path: '/mrt/phoneLostFlow',
    name: 'phoneLost',
    component: PhoneLost,
    meta: { title: '会社携帯の盗難・紛失時の対応方法について' },
  },
  {
    path: '/mrt/welfare/:id',
    name: 'welfare',
    component: Welfare,
    meta: { title: '制度・福利厚生' },
    props: true,
  },
  {
    path: '/mrt/welfareList/',
    name: 'welfareList',
    component: WelfareList,
    meta: { title: '制度・福利厚生一覧' },
  },
  {
    path: '/mrt/guidelinesForAction/',
    name: 'guidelinesForAction',
    component: GuidelinesForAction,
    meta: { title: '行動指針' },
  },
];

export default MrtRoute;
